import SendSuggestionBadge from '@/assets/img/scorecard/task_badges/send-suggestion.svg'
import LoginBadge from '@/assets/img/scorecard/task_badges/login.svg'
import DailyCheckInBadge from '@/assets/img/scorecard/task_badges/daily-check-in.svg'

export interface TaskInfo {
    expires: string,
    achievements: AchievementDetails[]
}

export interface AchievementDetails {
    type: TaskAchievement,
    title: string,
    blurb: string,
    progress: AchievementProgress
}

interface AchievementProgress {
    completed: number,
    total: number
}

type TaskAchievement = "login" | "checkin" | "suggestion"

export const AchievementBadges = {
    login: LoginBadge,
    checkin: DailyCheckInBadge,
    suggestion: SendSuggestionBadge
}

// TODO: Mock data - remove this once data is being fetched from API
export function getMockData() : TaskInfo {
    return  {
        expires: "1658452146",
        achievements: [
            {
                type: "login",
                title: "Daily Login",
                progress: {
                    completed: 30,
                    total: 30,
                },
                blurb: "Log in to the app daily"
            },
            {
                type: "checkin",
                title: "Complete Daily Check In",
                progress: {
                    completed: 15,
                    total: 30,
                },
                blurb: "Complete your daily check in on the app"
            },
            {
                type: "suggestion",
                title: "Send A Suggestion",
                progress: {
                    completed: 2,
                    total: 3,
                },
                blurb: "Suggest things that can be improved on"
            }
        ]
    }
}
